import { useMutation, useQuery, type UseQueryResult } from '@tanstack/react-query';

import { LEAVE_QUERY_KEYS } from './keys';

import * as leaveService from 'services/leave';

import { handleError } from 'utils/errorHandler';

import type { ServiceParams, ServicePayload } from 'interface/service';

export const getLeavesQueryKey = (params: ServiceParams = {}) => [LEAVE_QUERY_KEYS.LEAVES, params] as const;

export const leavesQueryOptions = (params: ServiceParams = {}) => ({
  queryKey: getLeavesQueryKey(params),
  queryFn: () => leaveService.fetch(params),
});

export const useFetchLeavesQuery = <TData = unknown>(
  params: ServiceParams = {},
  enabled = true
): UseQueryResult<TData, Error> => {
  return useQuery({
    ...leavesQueryOptions(params),
    enabled,
  }) as UseQueryResult<TData, Error>;
};

export const getCalculateLeaveQueryKey = (params: ServiceParams = {}) =>
  [LEAVE_QUERY_KEYS.CALCULATE_LEAVE, params] as const;

export const calculateLeaveQueryOptions = (params: ServiceParams = {}) => ({
  queryKey: getCalculateLeaveQueryKey(params),
  queryFn: () => leaveService.calculateLeave(params),
});

export const useCalculateLeaveQuery = <TData = unknown>(
  params: ServiceParams = {},
  enabled = true
): UseQueryResult<TData, Error> => {
  return useQuery({
    queryKey: getCalculateLeaveQueryKey(params),
    queryFn: () => leaveService.calculateLeave(params) as Promise<TData>,
    enabled,
  });
};

export const useSaveLeaveCreditsMutation = () => {
  return useMutation({
    mutationFn: (credits: ServicePayload) => leaveService.saveCredits(credits),
    onError: (error) => handleError(error),
  });
};
